module.exports = __webpack_public_path__ + "static/screen-esami-bezels-dark-12b41df0ee8a8a4fbc520c64d8ba195b.png";